import React, { useEffect } from "react";
import Login from "../components/Authentication/Login";
import homeImage from "../assets/homeImage.jpeg";
import { useNavigate } from "react-router-dom";



const LandingPage = () => {
  const navigate = useNavigate();
  

  useEffect(() => {
    const isAuthenticated = !!localStorage.getItem('access_token');
    if (isAuthenticated) {
        navigate('/news_highlights');
    }
}, [navigate]);

  return (
    <div className="bg-gray-50 min-h-screen flex flex-col items-center justify-center">
      <section className="bg-gray-50 min-h-screen flex items-center justify-center">
        <div className="flex flex-col md:flex-row bg-gray-100 rounded-lg shadow-lg max-w-6xl p-10 md:p-14 items-center">
          <div className="md:w-1/2 px-8 md:px-16">
            <h2 className="font-bold text-2xl text-[#000] mt-0">Welcome to vritat</h2>
            <Login />
          </div>

          <div className="md:w-1/2 md:pl-12 mt-10 md:mt-0">
            <img src={homeImage} className="rounded-lg" alt="Home" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;
